/**
 * Payments Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import { AsyncViewInvoicesDashboardComponent } from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view`}
        component={AsyncViewInvoicesDashboardComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
